// extracted by mini-css-extract-plugin
module.exports = {"carrier":"carrier_carrier__OWuzn","label":"carrier_label__qMBQv","logo":"carrier_logo__WZVnE"};